var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanedarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_657_16907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 8.77778C2.66602 7.99196 3.0172 7.23831 3.64233 6.68265C4.26745 6.12699 5.11529 5.81482 5.99935 5.81482H25.9994C26.8834 5.81482 27.7313 6.12699 28.3564 6.68265C28.9815 7.23831 29.3327 7.99196 29.3327 8.77778V26.5556C29.3327 27.3414 28.9815 28.095 28.3564 28.6507C27.7313 29.2064 26.8834 29.5185 25.9994 29.5185H5.99935C5.11529 29.5185 4.26745 29.2064 3.64233 28.6507C3.0172 28.095 2.66602 27.3414 2.66602 26.5556V8.77778Z",
    stroke: "#1E2D66",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.666 2.48145V9.14811",
    stroke: "#1E2D66",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 2.48145V9.14811",
    stroke: "#1E2D66",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 15.8148H29.3327",
    stroke: "#1E2D66",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_657_16907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanedarIcon);
export default __webpack_public_path__ + "static/media/Canedar_icon.be495b5efd2dde25d11ca386dda6debf.svg";
export { ForwardRef as ReactComponent };